import api from "../services/api";

/** Resuelve el id de propiedad CRM a partir de su referencia (p. ej. 10005-L). */
export async function resolverPropiedadIdPorReferencia(ref) {
  const referencia = String(ref || "").trim();
  if (!referencia) return null;

  try {
    const r = await api.get(`/propiedades/ubicacion-busqueda?ref=${encodeURIComponent(referencia)}`);
    if (r.data?.encontrada && r.data.id) return r.data.id;
  } catch {
    /* siguiente fallback */
  }

  try {
    const r = await api.get(`/propiedades/validar-ref/${encodeURIComponent(referencia)}`);
    if (r.data?.existe && r.data.propiedad?.id) return r.data.propiedad.id;
  } catch {
    /* siguiente fallback */
  }

  try {
    const r = await api.get(
      `/propiedades?buscar=${encodeURIComponent(referencia)}&cartera=todas&perPage=10`,
    );
    const lista = r.data?.data || [];
    const refNorm = referencia.toLowerCase();
    const exacta = lista.find((p) => String(p.referencia || "").trim().toLowerCase() === refNorm);
    return (exacta || lista[0])?.id || null;
  } catch {
    return null;
  }
}
